import createCache from "@emotion/cache";

import CssBaseline from "@mui/material/CssBaseline";
import { CacheProvider } from "@emotion/react";
import React, { ReactNode } from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import rtlPlugin from "stylis-plugin-rtl";
import { theme } from "./theme";

// import { AppRouterCacheProvider } from "@mui/material-nextjs/v13-appRouter";
// import { theme } from "@/configs/theme";

interface Props {
  children: ReactNode;
}

const MUIThemeComponent = (props: Props) => {
  // ** Props
  const { children } = props;

  const styleCache = () =>
    createCache({
      key: "rtl",
      prepend: true,
      stylisPlugins: [rtlPlugin],
    });

  return (
    // <AppRouterCacheProvider options={{ enableCssLayer: true }}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <CacheProvider value={styleCache()}>
        <CssBaseline />
        {children}
      </CacheProvider>
    </ThemeProvider>
    // </AppRouterCacheProvider>
  );
};

export default MUIThemeComponent;

// src/theme.ts
// import { createTheme } from "@mui/material/styles";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#1976d2", // match with Tailwind if you want
//     },
//     secondary: {
//       main: "#9c27b0",
//     },
//   },
//   typography: {
//     fontFamily: "Roboto, sans-serif",
//   },
// });

// export default theme;
